/* eslint-disable jsx-a11y/iframe-has-title */
import {Spinner} from '@volkswagen-onehub/components-core';
import React, {useRef, useState} from 'react';
import Div from '../components/Div.styled';
import {config} from '../environment';
import useMediaQuery from '../hooks/useMediaQuery';

const EVMapIframe = () => {
  const {isDesktop} = useMediaQuery();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const handleLoad = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      setTimeout(() => setIsLoaded(true), 3500);
      console.log('Iframe loaded successfully!');
    }
  };

  return (
    <Div padding={isDesktop ? '100px 0 0 0' : '40px 0 0 0'}>
      <Div
        customStyles={{
          position: 'relative',
          height: '500px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignContent: 'flex-end',
        }}
      >
        {!isLoaded && (
          <div
            style={{
              height: '500px',
              width: '100%',
              backgroundColor: '#f5f5f5',
              backgroundImage: `url(${config.EV_FIT_ASSETS_BASE_URL}ev-fit-map-skeleton-min.png)`,
              position: 'absolute',
              backgroundSize: 'cover',
              left: 0,
              top: 0,
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                backgroundColor: '#f5f5f5',
                opacity: 0.5,
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%,-50%)',
                }}
              >
                <Spinner variant="large" />
              </div>
            </div>
          </div>
        )}
        <iframe
          ref={iframeRef}
          src="https://www.plugshare.com/widget2.html?latitude=-25.64&longitude=138.07&spanLat=39.01&spanLng=172.08&plugs=1,2,3,4,5,6,42,13,7,8,9,10,11,12,14,15,16,17"
          width="100%"
          height="500"
          allow="geolocation"
          style={{border: 'none'}}
          onLoad={handleLoad}
        />
      </Div>
    </Div>
  );
};

export default EVMapIframe;
